import React from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { Purchase } from './Purchase';
import { BASE_INVESTMENT } from 'utils';

export const PurchaseProvider: React.FC = () => {
  const stripePromise = loadStripe(BASE_INVESTMENT || '');

  return (
    <Elements stripe={stripePromise}>
      <Purchase />
    </Elements>
  );
};
